export const PDFType = {
  singleSidedPdf: 'singleSidedPdf',
  doubleSidedPdf: 'doubleSidedPdf',
  miniBookPdf: 'miniBookPdf',
  colourPdf: 'colourPdf',
  blackAndWhitePdf: 'blackAndWhitePdf',
  singleBwPdf: 'singleBwPdf',
  doubleBwPdf: 'doubleBwPdf',
  miniBookBwPdf: 'miniBookBwPdf',
} as const

export type PDFType = ValuesOf<typeof PDFType>

export const PDF_TYPES = [
  PDFType.singleSidedPdf,
  PDFType.doubleSidedPdf,
  PDFType.miniBookPdf,
  PDFType.colourPdf,
  PDFType.blackAndWhitePdf,
  PDFType.singleBwPdf,
  PDFType.doubleBwPdf,
  PDFType.miniBookBwPdf,
] as const
